import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: '350%',
    height: 'auto',
    maxWidth: '200px',
    display: 'block',
    margin: '0 auto',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div>
      <img
        className={classes.svg}
        src="/iConstruye-Logo.png"
        alt="iConstruye Catalog Logo"
      />
    </div>
  );
};

export default LogoFull;
